(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement-yotpo-rating"] && !Shopify.designMode) return;
  try {
    (() => {
    class JAYotpoTrustBar extends HTMLElement {
      static requests = new Map();

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        const configElement = this.querySelector('[data-yotpo-trust-bar-config]');
        const ratingElement = this.querySelector('[data-yotpo-trust-rating]');
        const countElement = this.querySelector('[data-yotpo-trust-count]');
        const linkElement = this.querySelector('a');

        if (!configElement || !ratingElement || !countElement || !linkElement) return;

        try {
          this.config = JSON.parse(configElement.textContent);
        } catch (error) {
          this.setAttribute('aria-busy', 'false');
          return;
        }

        JAYotpoTrustBar.getTotals(this.config.storeId)
          .then(({ rating, count }) => {
            if (!Number.isFinite(rating) || !Number.isFinite(count) || count <= 0) return;

            const decimals = Number(this.config.ratingDecimals) || 2;
            const ratingText = new Intl.NumberFormat(this.config.locale, {
              minimumFractionDigits: decimals,
              maximumFractionDigits: decimals,
            }).format(rating);
            const countText = new Intl.NumberFormat(this.config.locale).format(count);
            const reviewLabel = count === 1 ? this.config.reviewOne : this.config.reviewOther;

            ratingElement.textContent = `${ratingText} ${this.config.outOfFive}`;
            countElement.textContent = `${countText} ${reviewLabel}`;
            linkElement.setAttribute(
              'aria-label',
              this.config.linkLabel.replace('__rating__', ratingText).replace('__count__', countText)
            );
          })
          .catch(() => {})
          .finally(() => this.setAttribute('aria-busy', 'false'));
      }

      static getTotals(storeId) {
        if (!this.requests.has(storeId)) {
          const cacheKey = `ja-yotpo-trust-bar:${storeId}`;
          let cachedTotals;

          try {
            cachedTotals = JSON.parse(sessionStorage.getItem(cacheKey));
          } catch (error) {
            cachedTotals = null;
          }

          if (cachedTotals && Date.now() - cachedTotals.cachedAt < 60 * 60 * 1000) {
            this.requests.set(storeId, Promise.resolve(cachedTotals.data));
          } else {
            const request = this.fetchTotals(storeId).then((data) => {
              try {
                sessionStorage.setItem(cacheKey, JSON.stringify({ cachedAt: Date.now(), data }));
              } catch (error) {
                // Storage can be unavailable in privacy-restricted browser sessions.
              }

              return data;
            });

            this.requests.set(storeId, request);
          }
        }

        return this.requests.get(storeId);
      }

      static async fetchTotals(storeId) {
        const encodedStoreId = encodeURIComponent(storeId);
        const [productBottomlines, siteData] = await Promise.all([
          this.fetchProductBottomlines(encodedStoreId),
          this.fetchJson(
            `https://api-cdn.yotpo.com/v1/widget/${encodedStoreId}/products/yotpo_site_reviews/reviews.json?per_page=1&page=1`
          ),
        ]);

        const productsById = new Map();

        productBottomlines.forEach((bottomline) => {
          const productId = String(bottomline.domain_key || '');
          const count = Number(bottomline.total_reviews) || 0;
          const existing = productsById.get(productId);

          if (productId && (!existing || count > existing.total_reviews)) {
            productsById.set(productId, {
              product_score: Number(bottomline.product_score) || 0,
              total_reviews: count,
            });
          }
        });

        let totalCount = 0;
        let ratingPoints = 0;

        productsById.forEach((bottomline) => {
          totalCount += bottomline.total_reviews;
          ratingPoints += bottomline.product_score * bottomline.total_reviews;
        });

        const siteBottomline = siteData?.response?.bottomline || {};
        const siteCount = Number(siteBottomline.total_review || siteData?.response?.pagination?.total) || 0;
        const siteRating = Number(siteBottomline.average_score) || 0;

        totalCount += siteCount;
        ratingPoints += siteRating * siteCount;

        if (totalCount <= 0) throw new Error('No published Yotpo reviews found');

        return {
          rating: ratingPoints / totalCount,
          count: totalCount,
        };
      }

      static async fetchProductBottomlines(storeId) {
        const perPage = 100;
        const bottomlines = [];

        for (let page = 1; page <= 50; page += 1) {
          const data = await this.fetchJson(
            `https://api.yotpo.com/v1/apps/${storeId}/bottom_lines?count=${perPage}&page=${page}`
          );
          const pageBottomlines = data?.response?.bottomlines || [];

          bottomlines.push(...pageBottomlines);
          if (pageBottomlines.length < perPage) break;
        }

        return bottomlines;
      }

      static async fetchJson(url) {
        const response = await fetch(url, {
          credentials: 'omit',
          headers: { Accept: 'application/json' },
        });

        if (!response.ok) throw new Error(`Yotpo request failed with ${response.status}`);
        return response.json();
      }
    }

    if (!customElements.get('ja-yotpo-trust-bar')) {
      customElements.define('ja-yotpo-trust-bar', JAYotpoTrustBar);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    (() => {
    const requestCache = window.JAYotpoReviewRequests || new Map();
    window.JAYotpoReviewRequests = requestCache;

    const fetchRating = (url) => {
      if (requestCache.has(url)) return requestCache.get(url);

      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 8000);
      const request = fetch(url, {
        credentials: 'omit',
        headers: { Accept: 'application/json' },
        signal: controller.signal,
      })
        .then((response) => {
          if (!response.ok) throw new Error(`Yotpo request failed: ${response.status}`);
          return response.json();
        })
        .catch((error) => {
          requestCache.delete(url);
          throw error;
        })
        .finally(() => window.clearTimeout(timeout));

      requestCache.set(url, request);
      return request;
    };

    class YotpoProductRating extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        const storeId = this.dataset.storeId;
        const productId = this.dataset.productId;
        if (!storeId || !productId) {
          this.hideRating();
          return;
        }

        const url = `https://api-cdn.yotpo.com/v1/widget/${encodeURIComponent(storeId)}/products/${encodeURIComponent(productId)}/reviews.json?page=1&per_page=1`;
        fetchRating(url)
          .then((payload) => this.renderRating(payload?.response?.bottomline))
          .catch(() => this.hideRating());
      }

      renderRating(bottomline) {
        const rating = Number(bottomline?.average_score);
        const count = Number(bottomline?.total_review);
        if (!Number.isFinite(rating) || rating <= 0 || !Number.isFinite(count) || count <= 0) {
          this.hideRating();
          return;
        }

        window.JAProductReviewSchema?.update(rating, count);

        const stars = this.querySelectorAll('.stars');
        stars.forEach((star, index) => {
          const percentage = Math.max(0, Math.min(1, rating - index)) * 100;
          star.querySelector('[data-rating-fill-start]')?.setAttribute('offset', `${percentage}%`);
          star.querySelector('[data-rating-fill-end]')?.setAttribute('offset', `${percentage}%`);
        });

        const formattedRating = rating.toFixed(1);
        const reviewLabel = count === 1 ? this.dataset.reviewOne : this.dataset.reviewOther;
        const starsContainer = this.querySelector('[data-yotpo-rating-stars]');
        starsContainer?.setAttribute('aria-label', this.dataset.ratingLabel.replace('__rating__', formattedRating));

        const countElement = this.querySelector('[data-yotpo-rating-count]');
        if (countElement) countElement.textContent = String(count);
        const countLabel = this.querySelector('[data-yotpo-rating-count-label]');
        if (countLabel) countLabel.textContent = reviewLabel;
        const link = this.querySelector('.rating-link');
        link?.setAttribute(
          'aria-label',
          this.dataset.linkLabel
            .replace('__rating__', formattedRating)
            .replace('__count__', String(count))
            .replace('__review_label__', reviewLabel)
        );
        this.classList.remove('yotpo-product-rating--pending');
        this.removeAttribute('aria-hidden');
      }

      hideRating() {
        this.hidden = true;
      }
    }

    if (!customElements.get('yotpo-product-rating')) {
      customElements.define('yotpo-product-rating', YotpoProductRating);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
